import { flatMap, reject } from "lodash";
import { Chip } from "primereact/chip";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import { useTranslation } from "react-i18next";
import { Typography } from "../../../../common/components";
import { MultiSelect } from "../../../../common/components/MultiSelect";
import { TYPOGRAPHY_TYPE } from "../../../../common/components/Typography";
import { SpacePurpose } from "../../models";
import { useSetUpSpacesStore } from "../../store";

interface SpaceNamesProps {
    spacePurpose: SpacePurpose;
    isReadOnly?: boolean;
}

const SpaceNames = (props: SpaceNamesProps) => {
    const { spacePurpose, isReadOnly } = props;

    const {
        spaces: allSpaces,
        spacePurposes,
        setSpacesForSpacePurpose,
    } = useSetUpSpacesStore();

    const { t } = useTranslation("setUpSpaces");

    const allSelectedSpaces = flatMap(spacePurposes, "spaces");

    const disabledSpaces = reject(allSelectedSpaces, (selectedSpace) =>
        spacePurpose.spaces.includes(selectedSpace)
    );

    const PanelFooter = () => (
        <div className="p-2">
            <b>{spacePurpose.spaces.length}</b>&nbsp;
            {t("spacePurposes.spacesSelected")}
        </div>
    );

    return (
        <Typography
            type={TYPOGRAPHY_TYPE.bodyExtraSmallBold}
            className="flex flex-col gap-1"
        >
            {isReadOnly ? (
                <div className="flex flex-row flex-wrap flex-start gap-1 grow-[2]">
                    {spacePurpose.spaces.map((space) => (
                        <Chip key={space.name} label={space.name} />
                    ))}
                </div>
            ) : (
                <MultiSelect
                    filter
                    placeholder={t("spacePurposes.assignSpaces") || ""}
                    options={allSpaces}
                    value={spacePurpose.spaces}
                    optionLabel="name"
                    onChange={(e: MultiSelectChangeEvent) =>
                        setSpacesForSpacePurpose(spacePurpose, e.value)
                    }
                    optionDisabled={(option) => disabledSpaces.includes(option)}
                    selectedItemsLabel={`{0} ${t(
                        "spacePurposes.spacesSelected"
                    )}`}
                    maxSelectedLabels={3}
                    panelFooterTemplate={PanelFooter}
                />
            )}
        </Typography>
    );
};

export default SpaceNames;
